import React from 'react';
import cx from 'classnames';
import { parse } from 'querystring';
import type { WeddingSearchHit } from '@zola/svc-web-api-ts-client';
import searchSuggestionEvent from '@zola-helpers/client/dist/es/tracking/searchSuggestionEvent';

import { MOBILE_MAX } from '@zola-helpers/client/dist/es/util/responsive';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import styles from './CoupleSearchResult.module.less';

interface CoupleSearchResultProps {
  result: WeddingSearchHit;
  index: number;
}

function convertDatetime(datetime: Date) {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  };
  return new Date(datetime).toLocaleString('en-US', options);
}

const CoupleSearchResult: React.FC<CoupleSearchResultProps> = ({ result, index }) => {
  const href = result.public_wedding_account_id
    ? `/wedding/${result.slug}`
    : `/registry/${result.slug}`;

  function trackClickEvent() {
    const { query } = parse(window.location.search.split('?')[1]);
    if (query) {
      const payload = {
        query: query as string,
        section: 'FIND A COUPLE',
        search_type: 'COUPLE',
        position: index + 1,
        value: `${result.owner_name} & ${result.partner_name}`,
      };
      searchSuggestionEvent(payload);
    }
  }

  function clickHandler() {
    if (window.innerWidth <= MOBILE_MAX) {
      // TRACKING
      trackClickEvent();
      window.location.href = href;
    }
  }

  const nameLink = () => {
    return (
      // eslint-disable-next-line
      <span className={cx(styles.nameLink)} onClick={trackClickEvent}>
        <LinkV2 href={href} arrow>
          {result.owner_name} & {result.partner_name}
        </LinkV2>
      </span>
    );
  };

  const name = () => {
    const nameText = (
      <LinkV2 href={href} arrow>
        {result.owner_name} & {result.partner_name}
      </LinkV2>
    );

    return (
      // eslint-disable-next-line
      <span className={styles.name} onClick={trackClickEvent}>
        {nameText}
      </span>
    );
  };
  return (
    // eslint-disable-next-line
    <div className={styles.container} onClick={clickHandler}>
      <div className={cx(styles.result)}>
        {name()}
        {nameLink()}
        <span className={styles.date}>
          {result.event_date ? convertDatetime(result.event_date) : ''}
        </span>
      </div>
    </div>
  );
};

export default CoupleSearchResult;
